// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner[data-v-2699bc48]{display:flex;justify-content:space-evenly;align-items:center}.banner .datum[data-v-2699bc48]{text-align:center;margin-right:5px}.banner[data-v-2699bc48] label{color:var(--info)}", ""]);
// Exports
module.exports = exports;
